// Estimate PAL (Physical Activity Level)
// @see {@link https://en.wikipedia.org/wiki/Harris–Benedict_equation#Step_2_–_Determine_Total_Intake}
import { PROFILE_GENDER, PROFILE_TRAINING_FREQUENCY } from '../../../../models'
import { differenceInYearsDateUtil } from 'packages/src'

const TRAINING_FREQUENCY_TO_PHYSICAL_ACTIVITY_LEVEL = {
  [PROFILE_TRAINING_FREQUENCY.NOT_ACTIVE]: 1.5,
  [PROFILE_TRAINING_FREQUENCY.OCCASIONALLY]: 1.6,
  [PROFILE_TRAINING_FREQUENCY.FREQUENTLY]: 1.8,
  [PROFILE_TRAINING_FREQUENCY.VERY_FREQUENTLY]: 2
}

/**
 * Calculates BMR (Basal Metabolic Rate)
 * @see {@link https://en.wikipedia.org/wiki/Harris%E2%80%93Benedict_equation
 * @param heightInMeters
 * @param gender
 * @param birthday
 * @param weightInKgs
 * @returns {*}
 */
export const getBMRProfileUtil = ({
  heightInMeters,
  gender,
  birthday,
  weightInKgs
}) => {
  let bmr
  const heightInCms = heightInMeters * 100
  const age = differenceInYearsDateUtil(new Date(), new Date(birthday), 'years')
  if (gender === PROFILE_GENDER.MALE) {
    bmr = Math.round((10 * weightInKgs) + (6.25 * heightInCms) - (5 * age) + 5)
  } else {
    bmr = Math.round((10 * weightInKgs) + (6.25 * heightInCms) - (5 * age) - 161)
  }

  return bmr
}

// Calculate TDEE (Total daily energy expenditure)
// @see {@link
// https://en.wikipedia.org/wiki/Harris–Benedict_equation#Step_2_–_Determine_Total_Intake}
export const getTDEEProfileUtil = ({
  bmr,
  trainingFrequency
}) => {
  if (!bmr) {
    return 1500
  }

  trainingFrequency = trainingFrequency || PROFILE_TRAINING_FREQUENCY.NOT_ACTIVE
  const physicalActivityLevel = TRAINING_FREQUENCY_TO_PHYSICAL_ACTIVITY_LEVEL[trainingFrequency]
  return Math.round(bmr * physicalActivityLevel)
}
